import { hoursBackForIncendioCards } from './constants'

export const rangoPorDefectoIncendios = (() => {
  const fin = new Date()
  const ini = new Date(fin)
  ini.setHours(fin.getHours() - hoursBackForIncendioCards)
  return [ini, fin]
})()
